import { MDBCol, MDBContainer, MDBRow } from 'mdbreact'
import React from 'react'
import { Spinner } from 'react-rainbow-components'

const CustomLoader: React.FC = () => {
    return (
        <>
            <MDBContainer fluid={true}>
                <MDBRow className='py-5'>
                    <MDBCol size='12'>
                        <Spinner size="large" variant='brand' />
                    </MDBCol>
                </MDBRow>
                <MDBRow className=''>
                    <MDBCol size='12'>
                        <div className='text-center'>Chargement...</div>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </>
    )
}
export default CustomLoader
